import React from "react";
import { CustomButton } from "../CustomButton";
import { Card, CardActions, CardContent, Grid, Tooltip } from "@mui/material";
import { convertirLetraMayus } from "../../helpers/convertirLetraMayus";

export const CardExtraction = ({ title, description, action }) => {

    return (
        <Grid items="true" sx={{ cursor: 'pointer' }}>
            <Tooltip title={ convertirLetraMayus(description) }>
                <Card sx={{ maxWidth: 250, mt: 2 }}>
                    <CardContent>
                        <h4>{ title }</h4>
                        <p style={{ fontSize: 14, marginTop: 10, textAlign: 'justify' }}>{ description?.substring(0, 80)+'...' }</p>
                    </CardContent>

                    <CardActions>
                        <CustomButton
                            name='Continuar'
                            action={ action }
                        />
                    </CardActions>
                </Card>
            </Tooltip>
        </Grid>
    )
}